import { Environment } from "../../const/environment";
import scriptDraftService from "../ScriptDraftService";

export const getScriptTextForScriptArea = async function (environment, script) {
    if (environment !== Environment.Staging) {
        return script.text;
    }
    return await scriptDraftService.getScriptText(script);
}